import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getQuoteState } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import setExpirationDate from "@insite/client-framework/Store/Pages/RfqQuoteDetails/Handlers/SetExpirationDate";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import { RfqQuoteDetailsPageContext } from "@insite/content-library/Pages/RfqQuoteDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    quoteState: getQuoteState(state, state.pages.rfqQuoteDetails.quoteId),
});

const mapDispatchToProps = {
    setExpirationDate,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface RfqQuoteDetailInformationStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    quoteDetailDate?: TypographyProps;
}

export const rfqQuoteDetailInformationStyles: RfqQuoteDetailInformationStyles = {
    wrapper: {
        css: css`
            padding-bottom: .625rem;
            font-family: 'Lato',sans-serif;
            font-size: 1rem;
            letter-spacing: 0;
            line-height: 1.5rem;
        `,
    },
    titleText: {
        variant: "h6",
        as: "h2",
        css: css`
            @media print {
                font-size: .75rem;
            }
            margin-bottom: .3125rem;
            margin-right: .3125rem;
            color: #002554;
            font-size: 1rem;
            line height: 1.5rem;
            font-family: 'Roboto', sans-serif;
            font-weight: bold;
            display: inline-block;
            &:after {
                content: ':';
                display: inline-block;
            }
        `,
    },
    quoteDetailDate: {
        css: css`
            color: #333F48;
            font-size: 1rem;
            line height: 1.5rem;
            font-family: 'Lato',sans-serif;
    `,
    },
    
};

const styles = rfqQuoteDetailInformationStyles;

const RfqQuoteDetailInformation = ({
    quoteState,
}: Props) => {
    const quote = quoteState.value;

    if (!quote) {
        return null;
    }

    return (
       
        <StyledWrapper data-test-selector="rfqQuoteDetailsCreate_Date_info">
             {quote.orderDate && (
                <StyledWrapper {...styles.wrapper}>
                    <Typography {...styles.titleText} id="createdQuoteDate">
                        {translate("Created Date")}
                    </Typography>

                    <Typography {...styles.quoteDetailDate} aria-labelledby="createdQuoteDate">
                        <LocalizedDateTime
                            dateTime={quote.orderDate}
                            options={{ year: "numeric", month: "numeric", day: "numeric" }}
                        />
                    </Typography>
                </StyledWrapper>
                
                )}
        </StyledWrapper>        

    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RfqQuoteDetailInformation),
    definition: {
        displayName: "Quote Detail Create Date",
        fieldDefinitions: [],
        group: "RFQ Quote Details",
    },
};

export default widgetModule;
